<script setup lang="ts">
/**
 * The message box under a conversation, as every conversation draws it (#244): what the page needs to say first
 * (the default slot: refusals, files on their way, quick replies, Stop), then the message itself, then Send, with
 * anything the page adds beside it (`tools`, such as Attach). Enter sends, Shift+Enter starts a new line. The Chat
 * page and Create task both draw it through ChatConversation, so the two cannot drift; sending stays with the page.
 */
import { Button, Textarea } from '@zerohuman/ui'

defineProps<{
    /** Whether Send may be pressed now. */
    canSend: boolean
    /** The conversation takes no messages (it is closed). */
    disabled?: boolean
}>()

const draft = defineModel<string>('draft', { required: true })
const emit = defineEmits<{ send: [] }>()
</script>

<template>
	<form class="shrink-0 border-t px-4 py-3 md:px-6 md:py-4" @submit.prevent="emit('send')">
		<slot />
		<Textarea
			v-model="draft"
			rows="2"
			:disabled="disabled"
			placeholder="Message…"
			@keydown.enter.exact.prevent="emit('send')"
		/>
		<div class="mt-2 flex items-center justify-between gap-3">
			<div class="flex min-w-0 items-center gap-2">
				<slot name="tools" />
			</div>
			<Button type="submit" size="sm" :disabled="!canSend">Send</Button>
		</div>
	</form>
</template>
